import Events from './Events';

const routes = [

  { path: 'events', element: <Events />},

]

  export default routes;